export const HIDE_SNOOZE_CONFIRMATION_LS_KEY = 'hideSnoozeConfirmation';

export type SNOOZE_DURATION = 'tomorrow' | 'later' | 'weekend' | 'nextweek' | 'custom';
export type SnoozeState = 'snooze-selection' | 'custom-snooze';
